export default "__VITE_ASSET__XiRWt_4K__"